import { TextField, TextFieldProps } from "@mui/material";
import "azure-maps-control/dist/atlas.min.css";
import { ChangeEvent } from "react";

import { GeoHelper } from "@/common/helpers/geo";
import { TypeHelper } from "@/common/helpers/type";

interface Props extends Omit<TextFieldProps, "type" | "inputMode" | "onChange"> {
  onChange?: (params: {
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>;
    newValue: Nil<number>;
  }) => void;
}

export default function LatitudeInput({ label = "Latitude", onChange, ...otherProps }: Props) {
  return (
    <TextField
      label={label}
      type='text'
      inputMode='decimal'
      onChange={(e) => {
        let newValue =
          !TypeHelper.isNil(e.target.value) && !TypeHelper.isEmptyString(e.target.value)
            ? GeoHelper.clampLatitude(+e.target.value)
            : undefined;
        newValue = newValue && newValue >= -90 && newValue <= 90 ? newValue : undefined;
        onChange &&
          onChange({
            e: e,
            newValue,
          });
      }}
      {...otherProps}
    />
  );
}
